import '../modalWrapper.scss';
import './modal-maintenance.scss';

import Settings from '../../../../assets/images/icons/settings.png';

import React, { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../../features';
import { setModalSignInUp } from '../../../../store/AppSlice';
import { modalTypeEnum } from '../../../../types/modal';

export const ModalMaintenance: FunctionComponent = () => {

    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setModalSignInUp(modalTypeEnum.none));
    }

    return (
        <div className="modal modal-maintenance">
            <img src={Settings} alt="manutenção" />
            <h1>
                Software em manutenção
            </h1>
            <p>
                O cadastro de novas carteiras está temporariamente indisponível enquanto realizamos melhorias no sistema. Por favor, tente novamente mais tarde.
            </p>
            <button onClick={handleClick}>
                Entendi
            </button>
        </div>
    )
}
